<template>
    <div class="animated fadeIn">
        <b-card no-body>
            <br />
            <b-container fluid>
                <b-row>
                    <b-col size="12">
                        <h3>
                            <b-badge>#{{ ticket.human_id }}</b-badge>
                            {{ ticket.subject }}
                        </h3>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col size="4">
                        Status:
                        <br />
                        <span class="font-weight-bold">{{
                            ticket.status.name
                        }}</span>
                    </b-col>
                    <b-col size="4">
                        Last Modified:
                        <br />
                        <span class="font-weight-bold">{{
                            getMomentFromNow(ticket.modified)
                        }}</span>
                    </b-col>
                    <b-col size="4" v-if="true">
                        Created By:
                        <br />
                        <span class="font-weight-bold">
                            {{ ticket.user.name }},
                            <span class="font-weight-bold">{{
                                getMomentFromNow(ticket.created)
                            }}</span>
                        </span>
                    </b-col>
                    <b-col size="4" v-if="true">
                        Priority:
                        <br />
                        <span class="font-weight-bold" v-if="ticket.priority">
                            {{ ticket.priority.name }}
                        </span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col size="12">
                        <hr />
                        <h3>Description</h3>
                        <blockquote
                            class="blockquote"
                            style="max-height: 300px; overflow-y: scroll; border: 1px solid #CCC; padding:1vh; word-break:break-all; background: #EEE"
                        >
                            <pre v-html="ticket.description"></pre>
                        </blockquote>
                    </b-col>
                </b-row>

                <b-row v-if="ticket.solution">
                    <b-col size="12">
                        <h3>Solution:</h3>
                        <blockquote class="blockquote">
                            <pre v-html="ticket.solution"></pre>
                        </blockquote>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col size="12">
                        <pre></pre>
                        <h3>Communications</h3>
                        <b-input-group>
                            <b-form-textarea
                                @click="showReplyBox = true"
                                placeholder="Write a messag and press send"
                                v-model="newMessageText"
                            ></b-form-textarea>
                            <b-input-group-append>
                                <b-button
                                    @click="saveComment()"
                                    :disabled="
                                        newMessageText.length < 5 &&
                                            !communicationlogLoading
                                    "
                                    variant="primary"
                                    >Send</b-button
                                >
                            </b-input-group-append>
                        </b-input-group>
                        <br />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col size="12">
                        <b-list-group>
                            <b-list-group-item v-if="communicationlogLoading">
                                <spinner />
                            </b-list-group-item>
                            <b-list-group-item
                                v-for="message in communicationlog"
                                :key="message.id"
                                class="flex-column align-items-start"
                            >
                                <div
                                    class="d-flex w-100 justify-content-between"
                                >
                                    <span>
                                        <b v-if="message.sender.userId">
                                            <i class="fa fa-user" />
                                            {{
                                                users[
                                                    'user_' +
                                                        message.sender.userId
                                                ]
                                            }}
                                        </b>
                                        <b
                                            v-if="
                                                !message.sender.user &&
                                                    message.sender.email
                                            "
                                        >
                                            <i class="fa fa-envelope" />
                                            {{ message.sender.email }}
                                        </b>
                                        <b
                                            v-if="
                                                !message.sender.user &&
                                                    !message.sender.email &&
                                                    message.sender.number
                                            "
                                        >
                                            <i class="fa fa-mobile" />
                                            {{ message.sender.number }}
                                        </b>
                                        {{ message.subject }}
                                    </span>

                                    <small>{{
                                        getMomentFromNow(message.created)
                                    }}</small>
                                </div>
                                <p class="mb-1" v-html="message.text"></p>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
                <br />
            </b-container>
        </b-card>
    </div>
</template>
<script>
// import tickets from '@/services/tickets'

import _ from 'lodash'
// import { get } from 'lodash/get'
import moment from 'moment'
import api from '@/http/http-common'

const $http = api

export default {
    name: 'Ticket',
    props: {
        ticket: {
            type: Object,
        },
    },
    components: {},
    data() {
        return {
            users: {},
            showReplyBox: false,
            communicationlogLoading: true,
            communicationlog: [],
            newMessageText: '',
            data: [],
        }
    },

    watch: {
        ticket() {
            this.communicationlog = []
            this.loadCommunicationLog()
        },
    },

    created() {
        // console.log('Ticket created', this.ticket)
        this.loadCommunicationLog()
    },

    computed: {
        tickets() {
            return this.data.tickets.map(ticket => {
                return ticket
            })
        },
    },

    methods: {
        saveComment() {
            this.$http
                .post(
                    '/services/tickets/' + this.ticket.id + '/communications',
                    {
                        subject: this.$store.getters['auth/user'].name,
                        text: this.newMessageText,
                    }
                )
                .then(() => {
                    this.newMessageText = ''
                    this.loadCommunicationLog()
                })
                .catch(() => {})
        },

        getMomentFromNow(ts) {
            try {
                return ts.fromNow()
            } catch (err) {
                return moment(0).fromNow()
            }
        },

        srcbtoa(text, attachments) {
            const regex = /<img[^>]+src="(api\/attachment\/thumbnail\/([^">]+))"/gim
            let newText = text

            let m
            while ((m = regex.exec(text)) !== null) {
                // This is necessary to avoid infinite loops with zero-width matches
                if (m.index === regex.lastIndex) {
                    regex.lastIndex++
                }
                //// console.log('MATCH', m, m[1], m[2])

                let attachment = attachments.find(a => a.contentId == m[2])
                if (!attachment) {
                    continue
                }

                newText = newText.replace(
                    m[1],
                    'data:' +
                        attachment.contentType +
                        ';charset=utf-8;base64,' +
                        attachment.thumbnail
                )
            }

            return newText
        },

        resolveUsers() {
            let userIds = Object.values(this.users)

            return $http
                .get('/services/tickets/user?ids=' + userIds.join(','))
                .then(res => {
                    let users = res.data

                    users.forEach(user => {
                        // console.log('user', user)

                        if (user.id === 3) {
                            this.users['user_' + user.id] = '' //this.$store.getters['auth/user'].name
                        } else {
                            this.users['user_' + user.id] = user.firstName
                        }
                    })
                })
        },

        loadCommunicationLog() {
            this.communicationlogLoading = true

            $http
                .request(
                    '/services/tickets/' + this.ticket.id + '/communications'
                )
                .then(data => {
                    this.communicationlogLoading = false
                    data = data.data

                    if (data.communications.length == 0) {
                        return
                    }

                    if (_.get(data, 'linked.communicationrecipients')) {
                        this.users = data.linked.communicationrecipients
                            .filter(msg => msg.userId !== null)
                            .reduce((acc, cur) => {
                                acc['user_' + cur.userId] = cur.userId
                                return acc
                            }, {})
                        this.resolveUsers()
                    }

                    this.communicationlog = data.communications.map(message => {
                        return {
                            id: message.id,
                            subject: message.subject,
                            created: moment(message.created),
                            modified: moment(message.modifed),
                            text: this.srcbtoa(
                                message.text,
                                data.linked.attachments
                            ),
                            sender: (sender => {
                                return {
                                    email: sender.email,
                                    number: sender.number,
                                    userId: sender.userId,
                                }
                            })(
                                data.linked.communicationrecipients.find(
                                    snder =>
                                        snder.id ==
                                        _.get(message, 'senderId', null)
                                )
                            ),
                        }
                    })
                })
        },
    },
}
</script>
